import { gql } from '@apollo/client';

export const GET_UPLOAD_TEMPORARY_ACCESS_MUTATION = gql`
  mutation getUploadTemporaryAccess(
    $contentType: String!
    $checksum: String!
    $contentLength: Long!
  ) {
    getUploadTemporaryAccess(
      contentType: $contentType
      checksum: $checksum
      contentLength: $contentLength
    ) {
      downloadURL
      key
      url
    }
  }
`;

export type UploadTemporaryAccessOutput = {
  getUploadTemporaryAccess: {
    downloadURL: string;
    key: string;
    url: string;
  };
};